<template>
    <v-layout
        row
    >
        <v-snackbar
            v-model="success"
            color="success"
            :timeout="5000"
            top
        >
            {{ msg }}
        </v-snackbar>
        <v-snackbar
            v-model="error"
            color="error"
            :timeout="5000"
            top
        >
            {{ error_msg }}
        </v-snackbar>
        <v-flex
            class="pl-4 pr-4"
        >
            <v-card class="ma-1">
                <v-tabs
                    v-model="tab"
                    background-color="#EBEFFD"
                    centered
                    show-arrows
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#outlets">
                        License
                    </v-tab>
                    <v-tab href="#sms">
                        SMS Statistic
                    </v-tab>
                    <v-tabs-items
                        v-model="tab"
                    >
                        <v-tab-item
                            :key="1"
                            :value="'outlets'"
                        >
                            <v-card>
                                <v-card-title>
                                    Outlets
                                </v-card-title>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="searchOutlets"
                                            append-icon="mdi-magnify"
                                            label="Search"
                                            hide-details
                                            class="ma-1"
                                            outlined
                                            autocomplete="off"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-card
                                    max-height="450"
                                >
                                    <v-data-table
                                        :headers="outletsHeaders"
                                        item-key="id"
                                        :items="Object.values(outlets)"
                                        :search="searchOutlets"
                                        dense
                                        class="display-3 font-weight-medium"
                                        :items-per-page="30"
                                        :fixed-header="true"
                                        height="450"
                                    >
                                        <template v-slot:top>
                                            <v-dialog
                                                v-model="dialog"
                                            >
                                                <v-card>
                                                    <v-card-title class="headline">
                                                        <v-row>
                                                            <v-col>
                                                                {{ editedItem.name }}
                                                            </v-col>
                                                            <v-spacer></v-spacer>
                                                            <v-col
                                                                class="text-end">
                                                                <v-btn
                                                                    color="success"
                                                                    v-if="!editedItem.license || (!editedItem.license.is_trial && !editedItem.license.onsite_activated_at && !editedItem.license.online_activated_at)"
                                                                    @click="trial(editedItem, 'open')"
                                                                >
                                                                    Open for Trial
                                                                </v-btn>
                                                                <v-btn
                                                                    color="success"
                                                                    v-if="editedItem.license && editedItem.license.is_trial"
                                                                    @click="trial(editedItem, 'end')"
                                                                >
                                                                    End Trial
                                                                </v-btn>
                                                            </v-col>
                                                            <v-col class="text-end">
                                                                <v-btn
                                                                    text
                                                                    @click="dialog = false"
                                                                >
                                                                    X
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-title>
                                                    <v-row class="ma-2">
                                                        <v-col>
                                                            <v-card>
                                                                <v-card-title>
                                                                    <v-row>
                                                                        <v-col>
                                                                            Onsite License
                                                                        </v-col>
                                                                        <v-spacer></v-spacer>
                                                                        <v-col
                                                                            class="text-end"
                                                                        >
                                                                            <v-btn
                                                                                v-if="!editedItem.license || (editedItem.license && (!editedItem.license.onsite_activated_at || editedItem.license.onsite_terminated_at))"
                                                                                color="primary"
                                                                                dark
                                                                                @click="activate(editedItem, 'onsite')"
                                                                            >
                                                                                Activate
                                                                            </v-btn>
                                                                            <v-btn
                                                                                v-if="(editedItem.license && editedItem.license.onsite_activated_at && !editedItem.license.onsite_terminated_at)"
                                                                                color="red"
                                                                                dark
                                                                                @click="terminate(editedItem, 'onsite')"
                                                                            >
                                                                                Terminate
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card-title>
                                                                <v-divider></v-divider>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card-subtitle>Activated on: {{
                                                                                editedItem.license && editedItem.license.onsite_activated_at ? formatDate(editedItem.license.onsite_activated_at) : '-'
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card-subtitle>Activated by: {{
                                                                                editedItem.license ? editedItem.license.onsite_activated_by : ''
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card-subtitle>Terminated on: {{
                                                                                editedItem.license && editedItem.license.onsite_terminated_at ? formatDate(editedItem.license.onsite_terminated_at) : '-'
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card-subtitle>Terminated by: {{
                                                                                editedItem.license ? editedItem.license.onsite_terminated_by : ''
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="ma-2">
                                                        <v-col>
                                                            <v-card>
                                                                <v-card-title>
                                                                    <v-row>
                                                                        <v-col>
                                                                            Online License
                                                                        </v-col>
                                                                        <v-spacer></v-spacer>
                                                                        <v-col
                                                                            class="text-end"
                                                                        >
                                                                            <v-btn
                                                                                v-if="!editedItem.license || (editedItem.license && (!editedItem.license.online_activated_at || editedItem.license.online_terminated_at))"
                                                                                color="primary"
                                                                                dark
                                                                                @click="activate(editedItem, 'online')"
                                                                            >
                                                                                Activate
                                                                            </v-btn>
                                                                            <v-btn
                                                                                v-if="(editedItem.license && editedItem.license.online_activated_at && !editedItem.license.online_terminated_at)"
                                                                                color="red"
                                                                                dark
                                                                                @click="terminate(editedItem, 'online')"
                                                                            >
                                                                                Terminate
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card-title>
                                                                <v-divider></v-divider>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card-subtitle>Activated on: {{
                                                                                editedItem.license && editedItem.license.online_activated_at ? formatDate(editedItem.license.online_activated_at) : '-'
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card-subtitle>Activated by: {{
                                                                                editedItem.license ? editedItem.license.online_activated_by : ''
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card-subtitle>Terminated on: {{
                                                                                editedItem.license && editedItem.license.online_terminated_at ? formatDate(editedItem.license.online_terminated_at) : '-'
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="5">
                                                                        <v-card-subtitle>Terminated by: {{
                                                                                editedItem.license ? editedItem.license.online_terminated_by : ''
                                                                            }}
                                                                        </v-card-subtitle>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-dialog>
                                        </template>
                                        <template v-slot:item.actions="{ item }">
                                            <v-btn
                                                color="primary"
                                                dark
                                                @click="editItem(item)"
                                            >
                                                License
                                            </v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item
                            :key="2"
                            :value="'sms'"
                        >
                            <sms-statistic
                                :groups="groups"
                                :outlets="outlets"
                            ></sms-statistic>
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'finance-panel',
    props: ['user'],
    data: () => ({
        groups: [],
        outlets: [],
        selectedOutlet: null,
        tab: null,
        searchOutlets: null,
        dialog: false,
        outletsHeaders: [
            {
                text: 'ID',
                align: 'start',
                value: 'id',
            },
            {
                text: 'Outlet Name',
                value: 'name',
            },
            {
                text: 'Description',
                value: 'description',
            },
            {
                text: 'Actions',
                value: 'actions',
                sortable: false
            }
        ],
        success: null,
        msg: null,
        error: null,
        error_msg: null,
        editedIndex: -1,
        editedItem: {
            name: '',
            description: '',
            license: {
                onsite_activated_at: '',
                onsite_activated_by: '',
                online_activated_at: '',
                online_activated_by: '',
                onsite_terminated_at: '',
                onsite_terminated_by: '',
                online_terminated_at: '',
                online_terminated_by: '',
                is_trial: 0,
                trail_expire: '',
            },
        },
        defaultItem: {
            name: '',
            description: '',
            license: {
                onsite_activated_at: '',
                onsite_activated_by: '',
                online_activated_at: '',
                online_activated_by: '',
                onsite_terminated_at: '',
                onsite_terminated_by: '',
                online_terminated_at: '',
                online_terminated_by: '',
                is_trial: 0,
                trail_expire: '',
            },
        },
    }),
    methods: {
        editItem(item) {
            this.editedIndex = this.outlets.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        closeDialog() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        async activate(item, license) {
            await axios.post('/api/finance/license/activate', {
                outlet_id: item.id,
                license: license,
                user_id: this.user.id
            }).then(response => {
                this.success = true
                this.msg = 'License successfully activated!'
            }).catch(e => {
                this.error = true
                this.error_msg = e
            })
            await axios.get('/api/finance/outlets').then(response => {
                this.outlets = response.data
            })
            this.dialog = false
        },
        async terminate(item, license) {
            await axios.post('/api/finance/license/terminate', {
                outlet_id: item.id,
                license: license,
                user_id: this.user.id
            }).then(response => {
                this.success = true
                this.msg = 'License successfully terminated!'
            }).catch(e => {
                this.error = true
                this.error_msg = e
            })
            await axios.get('/api/finance/outlets').then(response => {
                this.outlets = response.data
            })
            this.dialog = false
        },
        formatDate(date) {
            const d = moment(date)
            return d.format('YYYY-MM-DD')
        },
        async trial(item, action) {
            await axios.post('/api/finance/license/trial', {
                outlet_id: item.id,
                action: action,
                user_id: this.user.id
            }).then(response => {
                this.success = true
                if (action === 'open') {
                    this.msg = 'Trial activated successfully!'
                } else {
                    this.msg = 'Trial terminated successfully!'
                }
            }).catch(e => {
                this.error = true
                this.error_msg = e
            })
            await axios.get('/api/finance/outlets').then(response => {
                this.outlets = response.data
            })
            this.dialog = false
        }
    },
    beforeMount() {
        axios.get('/api/getGroups').then(response => {
            this.groups = response.data
        })
        axios.get('/api/finance/outlets').then(response => {
            this.outlets = response.data
        })
    }
}
</script>

<style>
.v-data-table-header th {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/FinancePanel.vue